export let notificationsWorker = null;

const createWorker = () => {
    if (typeof Worker === 'undefined') {
        console.warn('Web Workers not supported; notifications will process on main thread');
        return null;
    }

    try {
        return new Worker(
            new URL('./notificationsProcessor.worker.js', import.meta.url),
            { type: 'module' }
        );
    } catch (e) {
        console.warn('Failed to create notifications worker:', e);
        return null;
    }
};

/**
 * Initializes the worker and wires its output to Redux dispatch.
 * If existingNotifications are provided the worker is seeded with them
 * immediately so no prior notifications are lost on a restart.
 *
 * @param {Function}  dispatch
 * @param {Object[]}  [existingNotifications] - Already-processed Redux mirror
 *                    used to restore worker state after a restart.
 */
export const initializeWorker = (dispatch, existingNotifications = []) => {
    if (notificationsWorker) {
        return;
    }

    notificationsWorker = createWorker();
    if (!notificationsWorker) {
        return;
    }

    notificationsWorker.onmessage = (e) => {
        const msg = e.data;

        if (msg.type === 'PROCESSED-NOTIFICATIONS') {
            dispatch({
                type: 'UI-NOTIFICATIONS:WORKER-PROCESSED-NOTIFICATIONS',
                payload: {
                    notifications: msg.rows,
                    highestPriority: msg.highestPriority
                }
            });
        }
    };

    notificationsWorker.onerror = (e) => {
        console.warn('Notifications worker error:', e.message);
    };

    if (existingNotifications.length > 0) {
        postToWorker({ type: 'SEED', notifications: existingNotifications });
    }
};

export const disposeWorker = () => {
    if (!notificationsWorker) {
        return;
    }

    notificationsWorker.onmessage = null;
    notificationsWorker.onerror = null;
    notificationsWorker.terminate();
    notificationsWorker = null;
};

export const postToWorker = (msg) => {
    if (notificationsWorker) {
        notificationsWorker.postMessage({ ...msg });
    }
};